import { orchestrator } from 'satcheljs';
import setSearchTerm from '../actions/setSearchTerm';
import getStore from '../store/store';
import logFailedSearchTerm from '../utils/logFailedSearchTerm';
import setQuery from '../mutators/setQuery';
export default orchestrator(setSearchTerm, function (message) {
    var query = message.query;
    var isDeletion = query.length < getStore().query.length;
    if (isDeletion) {
        logFailedSearchTerm(getStore().query);
    }
    setQuery(query, isDeletion);
});
//# sourceMappingURL=onSetSearchTerm.js.map